exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination-container[data-v-b397ff92]  .el-pagination{text-align:right}", ""]);

// exports
